import { PollResultBar } from '../../atoms/PollResultBar';
import { PollResultLabel } from '../../atoms/PollResultLabel';
import { PollResultPercentage } from '../../atoms/PollResultPercentage';
import { PollResultRatio } from '../../atoms/PollResultRatio';
import { PollResultText } from '../../atoms/PollResultText';
import { PollResultBarWrapper } from '../PollResultBarWrapper';

interface Props {
    answer: string;
    index: number;
    totalVotes: number;
    votes: number;
}

export const PollResult = ({ answer, index, totalVotes, votes }: Props) => {
    return (
        <li className="relative flex items-start border-b border-transparent last:border-none px-2 pt-2 pb-3 after:absolute after:left-2 after:right-2 after:-bottom-px after:h-px after:bg-dashed-line-hor after:bg-[length:8px_1px] after:bg-repeat-x last:after:content-none">
            <PollResultLabel index={index} />
            <PollResultBarWrapper>
                <PollResultText answer={answer} />
                <PollResultBar votes={votes} totalVotes={totalVotes} />
                <div className="flex justify-between text-sm">
                    <PollResultRatio votes={votes} totalVotes={totalVotes} />
                    <PollResultPercentage votes={votes} totalVotes={totalVotes} />
                </div>
            </PollResultBarWrapper>
        </li>
    );
};
